/**
 * Library script
 * Created 12.05.22
 *
 * @author Christoph Ehlers <ce@construktiv.de> | Construktiv GmbH
 */

import LazyLoader from "../_shared/LazyLoader";
new LazyLoader().listen();